<template>
	<div>
		<header class="prelogin-header">
			<div class="container">
				<div class="row">
					<div class="col-md-12">
						<div class="header-logo">
							<a href="/" title="OnBlick Inc.,">
							<img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/src/assets/Images/site-logo.svg`" class="site-header__menu-logo" alt="OnBlick Inc.,">
							</a>
						</div>
					</div>
				</div>
			</div>
		</header>
		<section class="container-register_body">
          <div class="success_msg">
            <div class="row">
               <div class="col-md-12">
                  <div class="page_heading1" style="padding-top:15px;">
                     <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/src/assets/Images/ess_employee.svg`" alt="OnBlick" />
                     <h1 >Employee Self-Service Sign In</h1>
                  </div>
               </div>
            </div>
            <!-- Form -->
            <div v-if="isEssEnabled">
               <input type="hidden" id="CurrentTimeZone" name="CurrentTimeZone" />
               <input type="hidden" id="signIn" name="signIn" />
               <div class="row">
                  <div class="col-md-12">
                     <div class="inputContainer_new">
                        <input type="text" id="Email" v-model.trim="email" @blur="blurEmail" class="inputbox_input_new" :class="{ 'ob-vuelidate_input-error': $v.email.$error }" style="border-top: 1px solid #ddd;" />
                        <span class="ob-vuelidate_error-msg" v-if="$v.email.$dirty && !$v.email.required">Please enter email id</span>
                        <span class="ob-vuelidate_error-msg" v-if="$v.email.$dirty && !$v.email.email">Please enter valid email</span>
                        <span class="ob-vuelidate_error-msg" v-if="$v.email.$dirty && !$v.email.maxLength">Please enter 150 characters only</span>
                        <label class="input_label_new" v-bind:class="{ moveTop : isActiveEmail }" id="k">Email Address</label>
                     </div>
                  </div>
               </div>
               <div class="row">
                  <div class="col-md-12">
                     <div class="inputContainer_new">
                        <input type="password" @keyup.enter='loginMethodCheck' id="Password" v-model="password" @blur="blurPassword" class="inputbox_input_new password" :class="{ 'ob-vuelidate_input-error': $v.password.$error }"/>
                        <span class="ob-vuelidate_error-msg" v-if="$v.password.$dirty && !$v.password.required">Please enter your password</span>
                        <span class="ob-vuelidate_error-msg" v-if="$v.password.$dirty && !$v.password.minLength">Your password must contain more than 6 characters</span>
                        <span class="ob-vuelidate_error-msg" v-if="$v.password.$dirty && !$v.password.maxLength">Maximum 255 characters</span>
                        <label class="input_label_new" v-bind:class="{ moveTop : isActivePassword }">Password</label>
                     </div>
                  </div>
               </div>
               <div class="success_msg">
                  <div class="row">
                     <div class="col-md-12">
                        <div class="msg" id="LoginMsg">
                           <p style="color: Crimson;">{{ userMessage }}</p>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="row">
                  <div class="col-md-12">
                     <div class="create_account text-align-center">
                        <button @click="loginMethodCheck" class="btn--prelogin  btn--prelogin_min login_validation" id="LoginFirst" value="">Sign In</button>
                        <p class="forget-password">
                           <router-link to="ForgotPassword"><span>Forgot your password?</span></router-link>
                           <!-- <router-view></router-view> -->
                           <!-- <a href="ForgotPassword">
                              Forgot your password?
                              </a> -->
                        </p>
                     </div>
                  </div>
               </div>
            </div>
            <div v-else style="text-align:center;padding:30px;">
               <h1 class="disable_login" >Oops!</h1>
               <br/>
               <p class="disable_para">Your Employee Self-Service (ESS) has been disabled.<br/>Please contact your Employer.</p>
            </div>
         </div>
      </section>
      <footer class="footer">
         <div class="copyright text-center"> &copy; {{date}} OnBlick Inc., All rights reserved </div>
      </footer>
      <!-- cookies are disabled -->
      <div class="modal fade" id="CookiesDisabled" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
         <div class="modal-dialog CookiesDisabled" role="document">
            <div class="modal-content">
               <div class="modal-header">
                  <div class="modal-cookie-logo">
                     <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/src/assets/Images/site-logo.svg`" class="site-header__menu-logo" alt="OnBlick Inc.,">
                  </div>
               </div>
               <div class="modal-body">
                  <h4 class="modal-title modal-cookie-title">
                     <b>Enable Cookies</b>
                  </h4>
                  <p>Your browser has cookies disabled, please enable them and try again</p>
               </div>
               <div class="modal-footer align-center">
                  <button type="button" class="btn btn-primary" data-dismiss="modal">Ok</button>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
import {
  required,
  minLength,
  alph,
  email,
  numeric,
  url,
  maxLength
} from "vuelidate/lib/validators";
export default {
 	data() {
		return {
			date : new Date().getFullYear(),
			email: "",
			password: "",
			isActiveEmail: "",
			isActivePassword: "",
			//orgId:0,
			organizationLength:'',
			// router links
			routeToBasicInfo: {
				name: "ForgotPassword",
				query: this.$route.query
			},
      isEssEnabled: true,
      userMessage:''
		};
	},
	created() {
		this.isLoggedIn()
		this.$v.email.$reset();
		this.$v.password.$reset();
	},
	validations() {
		return {
			email: {
				required,
				email,
				maxLength: maxLength(150)
			},
			password: {
				required,
        minLength: minLength(6),
        maxLength: maxLength(255)
			}
		};
	},
  	methods: {
		redirectToPage() {
			let redirectPath = this.$route.query.redirect
			if(redirectPath && redirectPath != '') {
				this.$router.push({'path': redirectPath})
			} else if(this.organizationLength > 1 ) {
				this.$router.push({'name':'SelectOrganization'})
			}
			else{
				// window.createConnection()
				this.$router.push({'name':'ess-dashboard'})
			}
		},
		isLoggedIn() {
			if(session.isActive()) {
				// window.createConnection()
				this.$router.push({'name': 'ess-dashboard'})
      		}
			else if(localStorage.getItem('isESSDisabled')){
				this.isEssEnabled = false
				localStorage.removeItem('isESSDisabled')
			}
			else{
				this.userMessage = localStorage.getItem("expiry_message")
				localStorage.removeItem("expiry_message")
			}
		},
		loginMethodCheck(){
			this.$v.email.$touch();
			this.$v.password.$touch();
			if (this.$v.email.$invalid == false && this.$v.password.$invalid == false) {
				this.$loading({ 'loadingText': 'Loading...' })
				ajax.get(`Account/ValidateRole?email=${this.email.toLowerCase()}`, {}, (res) => {
					//alert("save method")
					if(res.data.State == false){
            			this.userMessage = res.data.Message
						/*this.$message({
							type: 'error',
							message: res.data.Message
              			}) */
              			this.$loading({}).close();
					}
					else{
						this.$loading({}).close();
						this.loginMethod();
					}
				})
			}
		},
		loginMethod() {

			this.$v.email.$touch();
			this.$v.password.$touch();
			if (this.$v.email.$invalid == false && this.$v.password.$invalid == false) {
				this.$loading({ 'loadingText': 'Loading...' })
				//alert("save method")
				let obj = {};
				obj.UserName = this.email.toLowerCase();
				obj.Password = this.password;
				obj.grant_type = "password";
				obj.Role = "Employee";

				var data = new URLSearchParams();
				data.append('userName', this.email.toLowerCase());
				data.append('Password', this.password);
				data.append('grant_type', 'password');
				data.append('Role', 'Employee');

				const url = "/Token"

				const requestBody = data

				const config = {
					headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
					}
				}

				axios.post(url, requestBody, config)
				.then((res) => {
					if(res.status != 200){
						this.$loading({}).close()
						this.userMessage = res.data.error_description
               }
               else{
                  if(res.data.error != undefined && res.data.error != null && res.data.error != ''){
                     // Login Fail
                     this.$loading({}).close()
                     this.userMessage = res.data.error_description
                  }
                  else{
            // Login success
            // Store access_token in localstorage
            localStorage.setItem("access_token", res.data.access_token)
            localStorage.setItem("refresh_token",res.data.refresh_token)
            // Refresth the access token
            ajax.refreshAccessToken()
            session.create()
            //get organization list api
            //this.org = true

            //ajax.get(`Employee/${this.email}/RedirectToOrganization`, {}, (res) => {
              //var OrgId = res.data
              //this.organizationId = OrgId
              //if(OrgId == '' ){
                ajax.get(`Employee/${this.email.toLowerCase()}/EmployeeOrganizationList`, {}, (res) => {
                var employee = res.data.organizationBasicInfoList.EmployeeInfo
                var organization = res.data.organizationBasicInfoList.OrganizationInfo
                this.organizationLength = organization.length
                var orgId = res.data.organizationBasicInfoList.OrganizationInfo[0].Id
                if (res.data.State == true) {
                  if( employee && organization && organization.length > 1){
                    this.$loading({}).close()
                    var userObj = {}
                    userObj.email = this.email.toLowerCase()
                    userObj.empId = employee.Id
                    userObj.name = employee.Name
                    userObj.designation = employee.Designation
                    userObj.profilepic = employee.ProfilePicLink
                    //userObj.SelectOrg = false
                    localStorage.setItem("user_details", JSON.stringify(userObj))
                    // update the employee details
                    ajax.updateUserDetails()
                    this.redirectToPage()
                  }
                  else{
                    if(!res.data.organizationBasicInfoList.OrganizationInfo[0].IsEssValidated){
                      this.$loading({}).close()
                      var userObj = {}
                      userObj.email = this.email.toLowerCase()
                      userObj.empId = employee.Id
                      userObj.name = employee.Name
                      userObj.designation = employee.Designation
                      userObj.profilepic = employee.ProfilePicLink
                      localStorage.setItem("user_details", JSON.stringify(userObj))
                      // update the employee details
                      ajax.updateUserDetails()
                      this.$router.push({'name':'SelectOrganization'})
                    }else{
                      this.ESSEnableDisable(res)
                      ajax.get(`/Employee/GetEmployeeDetails?orgId=${orgId}`, {}, (res) => {
                        this.$loading({}).close()
                        if (res.data.State == true) {
                        var userObj = {}
                        userObj.empId = res.data.EmpId
                        userObj.name = res.data.EmployeeContact.FirstName + ' ' + res.data.EmployeeContact.LastName
                        userObj.email = res.data.EmployeeContact.Email
                        userObj.orgId = res.data.OrgId
                        userObj.consultantId = res.data.ConsultantId
                        userObj.profilepic = res.data.ProfilePicLink
                        userObj.designation = res.data.Designation
                        userObj.IsH1B = res.data.IsH1B
                        userObj.OrgName = res.data.OrgName
                        userObj.OrgWebSite = res.data.OrgWebsite
                        userObj.HireType = res.data.HireType
                        userObj.IsSupervisor = res.data.IsSupervisor
                        //userObj.SelectOrg = false
                        //userObj.SingleOrg = true
                        // Update the employee details in local storage
                        localStorage.setItem("user_details", JSON.stringify(userObj))

                          // update the employee details
                          ajax.updateUserDetails()
                          // redirect to page
                          this.redirectToPage()

                        // show success message
                        // this.$message({
                        //   type: "success",
                        //   message: "Signed In successfully!"
                        // });
                        }
                        else
                          this.ESSEnableDisable(res)

                      })
                    }
                  }
                }
                else{
                  this.$loading({}).close()
                  this.ESSEnableDisable(res)
                  this.userMessage = res.data.Message
                  /* this.$message({
                    type: 'error',
                    message: res.data.Message
                  }) */
                }
              })
              //}

            }
          }
				})
				//})
				.catch((err) => {
					if(err.response != null && err.response.data != null && err.response.data.error != null){
						if(err.response.data.error == 'invalid_grant'){
            this.$loading({}).close()
            this.userMessage = err.response.data.error_description
						/* this.$message({
						type: "error",
						message: err.response.data.error_description
						}); */
						}
						else{
						this.isEssEnabled = false
						this.$loading({}).close()
						}
					}
					else{
            this.$loading({}).close()
            this.userMessage = "Error Login"
						/* this.$message({
							type: "error",
							message: "Error Login"
						}); */
					}
				})

			}
			// else {
			//   this.$message({
			//     type: "error",
			//     message: " Please enter the details to Sign in"
			//   });
			// }
		},
		blurEmail() {
			this.$v.email.$touch();
			if (this.email.toLowerCase() != "") {
				this.isActiveEmail = true;
			} else {
				this.isActiveEmail = false;
			}
		},
		blurPassword() {
				this.$v.password.$touch();
				if (this.password != "") {
					this.isActivePassword = true;
				} else {
					this.isActivePassword = false;
				}
		},
		GetToken() {
			alert(this.Email);
		}
  	}
};
</script>
<style lang="scss">
   /* @import '../assets/styles/login.css'; */
   @import '../../static/Css/Content/SCSS/post-login-scss/scss/login.scss';
   .container-register_body .ob-vuelidate_error-msg {
   position: absolute;
   top: 18px;
   right: 15px;
   font-size: 12px;
   color: #cc2550;
   }
   .disable_login{
   font-size: 40px;
   font-weight: 500;
   margin:0px;
   }
   .page_heading_disable{
   text-align: center;
   padding: 20px 0px;
   border-bottom: 0px;
   }
</style>



// WEBPACK FOOTER //
// src/components/LoginPage.vue